module.exports = __webpack_public_path__ + "img/newsImg11-26.306239b2.png";